export default function Footer() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-secondary-900 text-secondary-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            <div>
              <span className="font-heading text-lg font-bold text-secondary-50 mb-4 block">
                777影院
              </span>
              <p className="text-xs leading-relaxed text-secondary-400">
                777影院午夜伦不卡提供电影、电视剧、综艺等在线观看，高清画质，流畅不缓冲，
                免费看全集，极速播放体验。致力于打造全网最优质的影视内容聚合平台。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-secondary-100 mb-4">快速导航</h4>
              <div className="flex flex-col gap-2">
                {[
                  { label: '更新快讯', href: '#updates' },
                  { label: '专题索引', href: '#index' },
                  { label: '平台特色', href: '#features' },
                  { label: '联系我们', href: '#contact' },
                  { label: '关于我们', href: '#about' },
                ].map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    onClick={(e) => handleScroll(e, link.href)}
                    className="text-xs text-secondary-400 hover:text-secondary-100 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-secondary-100 mb-4">内容分类</h4>
              <div className="flex flex-col gap-2">
                {['电影大片', '热播剧集', '综艺娱乐', '动漫番剧', '纪录片', '少儿天地'].map((cat) => (
                  <a
                    key={cat}
                    href="#cards"
                    onClick={(e) => handleScroll(e, '#cards')}
                    className="text-xs text-secondary-400 hover:text-secondary-100 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-secondary-100 mb-4">合作伙伴</h4>
              <p className="text-xs text-secondary-500 leading-relaxed">
                合作伙伴信息即将上线，敬请期待。
              </p>
            </div>
          </div>

          <div className="border-t border-secondary-700/50 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-secondary-500">
              &copy; 2026 777影院 版权所有 | 高清影视在线观看平台
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" onClick={(e) => handleScroll(e, '#hero')} className="text-xs text-secondary-500 hover:text-secondary-200 transition-colors cursor-pointer whitespace-nowrap">
                回到顶部
              </a>
              <a href="#faq" onClick={(e) => handleScroll(e, '#faq')} className="text-xs text-secondary-500 hover:text-secondary-200 transition-colors cursor-pointer whitespace-nowrap">
                常见问答
              </a>
              <a href="#contact" onClick={(e) => handleScroll(e, '#contact')} className="text-xs text-secondary-500 hover:text-secondary-200 transition-colors cursor-pointer whitespace-nowrap">
                联系我们
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}